export default __webpack_public_path__ + "static/media/pos-logo.59b6a965.png";